// Footer.tsx
import {
  Box,
  Flex,
  Text,
  HStack,
  Image,
  Link,
  IconButton,
  VStack
} from '@chakra-ui/react'
import {
  FaFacebookF,
  FaDiscord,
  FaYoutube,
  FaRegNewspaper,
  FaTelegram
} from 'react-icons/fa'
import { EmailIcon } from '@chakra-ui/icons'

const Footer = () => {
  return (
    <Box bg="black" py={10} px={4}>
      <Flex
        maxW="6xl"
        mx="auto"
        direction={{ base: 'column', md: 'row' }}
        align="center"
        justify="space-between"
      >
        {/* 우측 정보 */}
        <Box mt={{ base: 8, md: 0 }} color="gray.300" fontSize="sm">
          <Text>Copyright © 2025 Togye. All rights reserved.</Text>
        </Box>
      </Flex>
    </Box>
  )
}

export default Footer
